import React, { useState, useEffect } from 'react';
import './Contact.css';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('contact');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);



  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-background">
          <img 
            src="https://res.cloudinary.com/dvybb2xnc/image/upload/v1757499584/How-to-become-a-vet_banner_gfsmm7.jpg" 
            alt="Veterinary Care Background" 
            className="contact-hero-image"
          />
        </div>
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-container">
          <div className="contact-hero-content">
            <h1 className="contact-hero-title">Contact Us</h1>
            <p className="contact-hero-description">
              Get in touch with our veterinary team for your pet's health and wellness needs
            </p>
          </div>
        </div>
      </section>

      <section id="contact" className={`contact ${isVisible ? 'contact-visible' : ''}`}>
        <div className="contact-container">
          <div className="contact-content">
                         <div className="contact-info">
               <div className="contact-cards">
                                   <div className="contact-card">
                    <div className="contact-card-icon">📍</div>
                    <h4 className="contact-card-title">Address</h4>
                    <p className="contact-card-value">Manama, Bahrain</p>
                  </div>
                  
                  <div className="contact-card">
                    <div className="contact-card-icon">📞</div>
                    <h4 className="contact-card-title">Phone</h4>
                    <p className="contact-card-value">+973 17676765</p>
                  </div>
                  
                  <div className="contact-card">
                    <div className="contact-card-icon">✉️</div>
                    <h4 className="contact-card-title">Email</h4>
                    <p className="contact-card-value">info@dentalcare.com</p>
                  </div>
                  
                  <div className="contact-card">
                    <div className="contact-card-icon">🕒</div>
                    <h4 className="contact-card-title">Hours</h4>
                    <p className="contact-card-value">
                      Mon-Fri: 9 AM - 6 PM<br />
                      Saturday: 9:00 AM - 3:00 PM<br />
                      Sunday: Emergency Only
                    </p>
                  </div>
               </div>
            </div>
            
                         {/* Map Section */}
             <div className="contact-map-section">
               <h3 className="map-title">Find Us</h3>
               <p className="map-subtitle">PMI, Road 4574, Block 745, Building 2486, Sanad 745</p>
               <div className="map-container">
                 <iframe
                   src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d230120.0!2d50.5853!3d26.0667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbh!4v1234567890123"
                   width="100%"
                   height="400"
                   style={{ border: 0 }}
                   allowFullScreen=""
                   loading="lazy"
                   referrerPolicy="no-referrer-when-downgrade"
                   title="Bahrain Map"
                   className="contact-map"
                 ></iframe>
                 <div className="map-overlay">
                   <a 
                     href="https://maps.app.goo.gl/MAkEexHwmWk4CNZG8?g_st=iw" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="map-link"
                   >
                     <div className="map-link-content">
                       <span className="map-link-icon">🗺️</span>
                       <span className="map-link-text">Open in Google Maps</span>
                     </div>
                   </a>
                 </div>
               </div>
             </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
